const getBaseUri = () => {
    
    return 'https://studiomaamangala.com/';
};

export default getBaseUri;
